export default __webpack_public_path__ + "static/media/setting_icon.621f6e1e.svg";